/** Gera ticks "redondos" para o eixo Y, no estilo d3.ticks. */
export function niceTicks(min: number, max: number, count = 4): number[] {
    if (min === max) {
        min -= 1
        max += 1
    }
    const range = max - min
    const rawStep = range / count
    const magnitude = 10 ** Math.floor(Math.log10(rawStep))
    const residual = rawStep / magnitude
    const niceResidual = residual >= 5 ? 10 : residual >= 2 ? 5 : residual >= 1 ? 2 : 1
    const step = niceResidual * magnitude

    const niceMin = Math.floor(min / step) * step
    const niceMax = Math.ceil(max / step) * step

    const ticks: number[] = []
    for (let v = niceMin; v <= niceMax + step * 0.5; v += step) {
        ticks.push(v)
    }
    return ticks
}
